import { Button, HorizontalSpacer, Label, Layout, Panel, Textbox, } from "@mcleod/components";

export abstract class AutogenLayoutUnassignCarrierPrompt extends Layout {
    advanceCarriersLabel: Label;
    buttonClose: Button;
    buttonNo: Button;
    buttonYes: Button;
    horizontalspacer4: HorizontalSpacer;
    labelTitle: Label;
    label_: Label;
    panel3: Panel;
    panelHeader: Panel;
    panelReason: Panel;
    textboxComments: Textbox;
    textboxReasonCode: Textbox;
}
